import QuantitySelector from '@/components/QuantitySelector';
import register from 'preact-custom-element';

register(QuantitySelector, 'quantity-selector');
